import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Card,
  Group,
  Loader,
  Select,
  Stack,
  Text,
} from "@mantine/core";
import toast from "react-hot-toast";

import { EmptyMessage } from "@components/shared";

const VARIETY_FILTER_OPTIONS = [
  { value: "1", label: "ClearScreen" },
  { value: "4", label: "Legacy ClearScreen" },
  { value: "2", label: "360" },
  { value: "3", label: "Engagement" },
];

function statusColor(status) {
  if (status === 1) return "green";
  if (status === 2) return "gray";
  if (status === 3) return "red";
  return "gray";
}

export default function ConceptualRootList({ refresh = false }) {
  const { t } = useTranslation();
  const [roots, setRoots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [variety, setVariety] = useState(null);

  useEffect(() => {
    fetchRoots();
  }, [refresh, variety]);

  function fetchRoots() {
    setLoading(true);
    const body = {
      page: 0,
      page_size: 100,
      status: "entire",
    };
    if (variety) body.variety = Number(variety);

    axios
      .post(`/retrieve-conceptual-roots/`, body)
      .then(({ data }) => {
        setRoots(data.response[0]?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  if (loading) {
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  return (
    <Stack gap="sm">
      <Select
        label={t("variety")}
        data={VARIETY_FILTER_OPTIONS}
        value={variety}
        onChange={setVariety}
        clearable
        placeholder={t("all")}
      />
      {!roots.length && <EmptyMessage />}
      {roots.map((root) => (
        <Card
          key={root.id}
          component={Link}
          to={`/conceptual-roots/${root.id}`}
        >
          <Group justify="space-between" align="flex-start">
            <div>
              <Text c="dark" fw={700}>
                {root.label || root.concept}
              </Text>
              <Text size="sm" c="dimmed">
                {root.concept}
                {root.variety_formatted ? ` · ${root.variety_formatted}` : ""}
              </Text>
            </div>
            <Badge variant="light" color={statusColor(root.status)}>
              {root.status_formatted || t("status")}
            </Badge>
          </Group>
        </Card>
      ))}
    </Stack>
  );
}
